import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/retryWhen';
import 'rxjs/add/operator/takeWhile';
import 'rxjs/add/operator/timeout';
import 'rxjs/add/operator/delay';
import { AccountStayPreferencesDataValidator } from './validators/data.validators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { DefaultRetryHandler } from './handlers/retry.handlers';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '../config';
import { ApigeeDAO } from './apigee.dao';
import { resolveLocale } from '../../common/common';
import { LogService } from '../services/logging.service';

const CLASS_NAME = 'AccountStayPreferencesDao';
const LANGUAGE_HEADER_NAME = 'accept-language';
@Injectable()
export class AccountStayPreferencesDao extends ApigeeDAO {
  constructor(http: HttpClient, @Inject(APP_CONFIG) appConfig: IAppConfig, log: LogService, cookieService: CookieService) {
    super(CLASS_NAME, http, appConfig, appConfig.accountStayPreferencesDAO, new DefaultRetryHandler(), new AccountStayPreferencesDataValidator(), log, cookieService);
  }
  protected buildHeaders(customHeaders?: { [key: string]: string }): HttpHeaders {
    let headers: HttpHeaders = super.buildHeaders(customHeaders);
    headers = headers.set(LANGUAGE_HEADER_NAME, resolveLocale(this.appConfig));
    return headers;
  }
  get(): Observable<any> {
    const url = this.daoConfig.url;
    return super.doGet(url);
  }

  put(stayPreferences: object): Observable<any> {
    const url = this.daoConfig.url;
    return super.doPut(url, stayPreferences, {}, {});
  }

}




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/account-stay-preferences.dao.ts